import { ChangeDetectionStrategy, Component, inject, input, Input } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Settings } from '@app/core/_models/settings';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { LanguagePickerComponent } from '@app/shared/components/loyalty-club-header/language-picker/language-picker.component';

interface SettingsData {
  languages: string[];
  websiteUrl: string;
  logoUrl: string;
  name: string;
  additionalIndexHtml: string;
}

const mapSettings = (settings: Settings, useSubunitName: boolean): SettingsData => ({
  languages: settings.schema.languages,
  websiteUrl: settings.website_url,
  logoUrl: settings.logo_url,
  name: useSubunitName ? settings.getSubunitDisplayName() : settings.name,
  additionalIndexHtml: settings.additional_index_html,
});

@Component({
  selector: 'app-loyalty-club-header',
  templateUrl: './loyalty-club-header.component.html',
  styleUrl: 'loyalty-club-header.component.scss',
  imports: [
    LanguagePickerComponent,
    AsyncPipe,
    NgTemplateOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoyaltyClubHeaderComponent {
  private settingsService = inject(SettingsService);

  public readonly settingsObservable: Observable<SettingsData>;

  public readonly customHTML = input<boolean>();

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  public set useSubunitName(userSubunitName: boolean) {
    this.useSubunitName$.next(userSubunitName);
  }

  private readonly useSubunitName$: BehaviorSubject<boolean>;

  constructor() {
    this.useSubunitName$ = new BehaviorSubject<boolean>(false);
    this.settingsObservable = this.mapSettings();
  }

  private mapSettings(): Observable<SettingsData> {
    return this.useSubunitName$.pipe(
      map((useSubunitName) => mapSettings(this.settingsService.settings, useSubunitName)),
    );
  }
}
